import { createSelector, createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

type PasswordSlice = {
    currentPassword: string
    newPassword: string
    confirmNewPassword: string
    isSavingChanges: boolean
}

const initialState: PasswordSlice = {
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    isSavingChanges: false,
}

export const passwordSliceName = "password" as const

export const {
    actions: { setCurrentPassword, setNewPassword, setConfirmNewPassword, setIsSavingChanges },
    reducer: PasswordSliceReducer,
} = createSlice({
    name: passwordSliceName,
    initialState,
    reducers: {
        setCurrentPassword: (state, action: { payload: PasswordSlice["currentPassword"] }) => {
            state.currentPassword = action.payload
        },
        setNewPassword: (state, action: { payload: PasswordSlice["newPassword"] }) => {
            state.newPassword = action.payload
        },
        setConfirmNewPassword: (
            state,
            action: { payload: PasswordSlice["confirmNewPassword"] }
        ) => {
            state.confirmNewPassword = action.payload
        },
        setIsSavingChanges: (state, action: { payload: PasswordSlice["isSavingChanges"] }) => {
            state.isSavingChanges = action.payload
        },
    },
})

const root = (state: RootState) => state[passwordSliceName]

export const selectCurrentPassword = createSelector([root], (s) => s.currentPassword)
export const selectNewPassword = createSelector([root], (s) => s.newPassword)
export const selectConfirmNewPassword = createSelector([root], (s) => s.confirmNewPassword)
export const selectIsSavingChanges = createSelector([root], (s) => s.isSavingChanges)
